import _getBuiltIn from "../internals/get-built-in";
import _wellKnownSymbolDefine from "../internals/well-known-symbol-define";
import _setToStringTag from "../internals/set-to-string-tag";
var getBuiltIn = _getBuiltIn;
var defineWellKnownSymbol = _wellKnownSymbolDefine;
var setToStringTag = _setToStringTag;

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol("toStringTag");

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag(getBuiltIn("Symbol"), "Symbol");
export default {};